import { supabase } from '@/lib/supabase';

export interface ImageHistoryEntry {
  id: string;
  version_type: string;
  storage_path: string;
  created_at: string;
  publicUrl: string;
}

interface HistoryRow {
  id: string;
  version_type: string;
  storage_path: string;
  created_at: string;
}

export async function fetchImageHistory(imageId: string): Promise<ImageHistoryEntry[]> {
  const { data, error } = await supabase.rpc('admin_get_image_history', {
    p_image_id: imageId,
  });
  if (error) throw new Error(`[adminImageHistoryService] ${error.message}`);
  const rows = (data ?? []) as HistoryRow[];
  return rows.map(row => ({
    ...row,
    publicUrl: supabase.storage.from('images').getPublicUrl(row.storage_path).data.publicUrl,
  }));
}
